import { NgModule, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
//
// Components
//
import { AppMenuComponent } from './app-menu.component';

@NgModule({
  imports: [CommonModule, MatIconModule, FlexLayoutModule],
  declarations: [AppMenuComponent],
  exports: [AppMenuComponent]
})
export class AppMenuComponentModule {
  constructor() {
  }
}
